import { Box } from '@mui/material'
import { toast } from 'react-hot-toast'

import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { useSettingsContext } from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { max } from 'lodash'

import { ServiceLevelTable } from './ServiceLevel.Table'
import { useServiceLevel, useUpdateServiceLevel } from './ServiceLevel.data'

export const ServiceLevelView = () => {
  const { state } = useSettingsContext()
  const { projectId, scenarioId } = state
  const { view_width, view_height } = useWindowSize()

  const { data: serviceLevelData, isLoading } = useServiceLevel({
    projectId,
    scenarioId,
  })

  const handleUpdateSuccess = () => {
    toast.success('Service level updated successfully')
  }

  const handleUpdateError = () => {
    toast.error('Failed to update service level')
  }

  const { mutate: updateServiceLevel, isPending: isUpdating } =
    useUpdateServiceLevel({
      projectId,
      scenarioId,
      onSuccess: handleUpdateSuccess,
      onError: handleUpdateError,
    })

  return (
    <Page>
      <Box
        display="flex"
        flex="auto"
        flexDirection="column"
        justifyContent="flex-start"
        maxWidth={view_width}
        maxHeight={max([view_height, 1500])}
      >
        <PageHeader title="Service Level" />
        <ServiceLevelTable
          data={serviceLevelData ?? []}
          isLoading={isLoading}
          updateTableData={updateServiceLevel}
          isSaving={isUpdating}
        />
      </Box>
    </Page>
  )
}
